import { NEXT_LOCALES } from '@beat-venues/common-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Navigate,
    Outlet,
    useLocation,
    useNavigate,
    useParams,
    useSearchParams,
} from 'react-router-dom';

import { NotFound } from '../../pages';
import { LayoutWrapper } from '../layout-wrapper';

const WithoutLanguage = () => {
    const { pathname } = useLocation();
    const { i18n } = useTranslation();
    const [searchParams] = useSearchParams();

    return (
        <Navigate
            replace
            to={`/${i18n.language}${
                pathname !== '/' ? `${pathname}?${searchParams.toString()}` : ''
            }`}
        />
    );
};

const WithLanguage = () => {
    const [notFound, setNotFound] = useState<boolean>(false);

    const params = useParams();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        if (
            !NEXT_LOCALES.includes(
                params.language as typeof NEXT_LOCALES[number]
            ) &&
            !notFound
        ) {
            setNotFound(true);
            return navigate('/not-found', { replace: true });
        }

        if (
            !!NEXT_LOCALES.includes(
                params.language as typeof NEXT_LOCALES[number]
            ) &&
            !!notFound
        ) {
            setNotFound(false);
        }
    }, [params.language, notFound]);

    useEffect(() => {
        if (i18n.language !== params.language) {
            const pathSegments = pathname.split('/').filter((n) => n);
            const currentRoute = pathSegments[1];

            // Translate current route to new language
            const newRoute = Object.keys(
                i18n.getResource(i18n.language, 'translation', 'routes') || {}
            ).find(
                (key) =>
                    i18n.getResource(
                        params.language || i18n.language,
                        'translation',
                        `routes.${key}`
                    ) === currentRoute
            );

            const newPath = [
                i18n.language,
                newRoute ? i18n.t(`routes.${newRoute}`) : pathSegments[1],
                ...pathSegments.slice(2),
            ];

            return navigate(`/${newPath.join('/')}`, { replace: true });
        }
    }, [i18n.language, navigate]);

    if (notFound) {
        return <NotFound />;
    }

    return (
        <LayoutWrapper>
            <Outlet />
        </LayoutWrapper>
    );
};

export { WithLanguage, WithoutLanguage };
